module.exports = __webpack_public_path__ + "img/garten.05ea88a5.jpeg";